<template>
  <div class="education">
    <div class="title">
      教育经历
      <el-tag type="danger">必填</el-tag>
      <info text="从高中开始填写" />
      <el-button
        v-show="!visible"
        type="primary"
        size="mini"
        plain
        style="margin-left: 50px"
        :disabled="!canEdit"
        :title="canEdit ? '' : isSpecific ? '投递岗位后无法再更改简历' : '请取消投递后再更改简历'"
        @click="editFunc"
        >添加</el-button
      >
    </div>
    <div v-if="eduList.length === 0 && !visible" class="desc">教育经历最能体现您的学历和专业能力，快来完成它吸引单位和HR青睐吧</div>
    <div v-show="!visible">
      <div v-for="item in eduList" :key="item.id" class="edu_item">
        <div class="left">
          <div class="part1">{{ item.school }}</div>
          <div class="part1">{{ formatDate('YYYY年MM月', new Date(item.startDate)) }}-{{ formatDate('YYYY年MM月', new Date(item.endDate)) }}</div>
          <div class="part1">
            <span>{{ dicOptions.hr_education.filter((d) => d.dictValue == item.education)[0]?.dictLabel }}</span>
            <span> | </span>
            <span>{{ dicOptions.degree_type.filter((d) => d.dictValue == item.degree)[0]?.dictLabel }}</span>
          </div>
          <div class="part1">
            <span>{{ item.major }}</span>
          </div>
        </div>
        <div class="actions">
          <el-button
            type="primary"
            size="mini"
            plain
            @click="editFunc(item)"
            :disabled="!canEdit"
            :title="canEdit ? '' : isSpecific ? '投递岗位后无法再更改简历' : '请取消投递后再更改简历'"
            >编辑</el-button
          >
          <el-button
            type="primary"
            size="mini"
            plain
            @click="deleteFunc(item)"
            :disabled="!canEdit"
            :title="canEdit ? '' : isSpecific ? '投递岗位后无法再更改简历' : '请取消投递后再更改简历'"
            >删除</el-button
          >
        </div>
      </div>
    </div>
    <el-form v-if="visible" ref="formRef" :model="formData" :rules="rules" label-width="130px" class="form">
      <div v-show="false">
        <!-- 简历id -->
        <el-form-item label="basicId：" prop="basicId">
          <el-input v-model="formData.basicId" />
        </el-form-item>
        <!-- 关系id -->
        <el-form-item label="Id：" prop="id">
          <el-input v-model="formData.id" />
        </el-form-item>
      </div>
      <el-row>
        <el-col :span="11">
          <el-form-item :label="EDUCATION.startDate + ':'" prop="startDate">
            <el-date-picker v-model="formData.startDate" type="month" placeholder="请选择开始时间" style="width: 100%"></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item :label="EDUCATION.endDate + ':'" prop="endDate">
            <el-date-picker v-model="formData.endDate" type="month" placeholder="请选择结束时间" style="width: 100%"></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item :label="EDUCATION.school + ':'" prop="school">
            <el-input v-model="formData.school" placeholder="请填写学校" :maxlength="50" clearable style="width: 100%" />
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item :label="EDUCATION.major + ':'" prop="major">
            <el-input v-model="formData.major" placeholder="请填写专业" :maxlength="50" clearable style="width: 100%" />
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item :label="EDUCATION.education + ':'" prop="education">
            <el-select v-model="formData.education" placeholder="请选择学历" filterable clearable style="width: 100%">
              <el-option
                v-for="item in dicOptions.hr_education.sort((a, b) => b.dictSort - a.dictSort)"
                :key="item.dictValue"
                :label="item.dictLabel"
                :value="item.dictValue"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item :label="EDUCATION.degree + ':'" prop="degree">
            <el-select v-model="formData.degree" placeholder="请选择学位" clearable style="width: 100%">
              <el-option
                v-for="item in dicOptions.degree_type.sort((a, b) => b.dictValue - a.dictValue)"
                :key="item.dictValue"
                :label="item.dictLabel"
                :value="item.dictValue"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item :label="EDUCATION.type + ':'" prop="type">
            <el-select v-model="formData.type" :placeholder="'请选择' + EDUCATION.type" clearable style="width: 100%">
              <el-option v-for="item in dicOptions.hr_edu_type" :key="item.dictValue" :label="item.dictLabel" :value="item.dictValue"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="11">
          <el-form-item :label="EDUCATION.witness + ':'" prop="witness">
            <el-input v-model="formData.witness" placeholder="请填写证明人" :maxlength="20" clearable style="width: 100%" />
          </el-form-item>
        </el-col> -->
      </el-row>
      <!-- <el-row>
        <el-col :span="22">
          <el-form-item :label="EDUCATION.fileUrl + ':'" prop="fileUrl">
            <el-upload
              class="upload-demo"
              accept="image/*,.pdf"
              action="/prod-api/recruitment/sso/uploadfile"
              name="uploadfile"
              :headers="{ Authorization: 'Bearer ' + getToken() }"
              :on-remove="handleRemove"
              :limit="fileCountMax"
              :before-upload="beforeUpload"
              :on-exceed="handleExceed"
              :on-success="handleSuccess"
              :file-list="fileList"
            >
              <el-button size="small" type="primary">点击上传</el-button>
              <template #tip>
                <div class="el-upload__tip">最多上传{{ fileCountMax }}张图片，支持JPG/PNG/PDF格式，文件大小10M以内</div>
              </template>
            </el-upload>
          </el-form-item>
        </el-col>
      </el-row> -->
      <el-form-item class="submit" label-width="0">
        <el-button type="primary" @click="onSubmit">保存</el-button>
        <el-button @click="onReset">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { reactive, watch, toRefs, computed } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { ElMessage } from 'element-plus';
import Info from '../../components/Info.vue';
import ApplicantApi from '../../service/api/applicant';
import { EDUCATION } from '../../utils/resume';
import { formatDate } from '../../utils/tools';
import { getToken } from '../../service/cookie';

export default {
  name: 'Education',
  components: { Info },
  props: {
    modelValue: {
      type: Object,
      default: () => ({}),
    },
    isSpecific: {
      type: Boolean,
      default: false,
    },
    canEdit: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['callback', 'update:modelValue'],
  setup(props, context) {
    const state = reactive({
      eduList: [],
      visible: false,
      formRef: null,
      formData: {},
      rules: {
        startDate: [{ required: true, message: EDUCATION.startDate + '必填', trigger: 'change' }],
        endDate: [{ required: true, message: EDUCATION.endDate + '必填', trigger: 'change' }],
        school: [{ required: true, message: EDUCATION.school + '必填', trigger: 'change' }],
        major: [{ required: true, message: EDUCATION.major + '必填', trigger: 'change' }],
        type: [{ required: true, message: EDUCATION.type + '必填', trigger: 'change' }],
        education: [{ required: true, message: EDUCATION.education + '必填', trigger: 'change' }],
        degree: [{ required: true, message: EDUCATION.degree + '必填', trigger: 'change' }],
        witness: [{ required: true, message: EDUCATION.witness + '必填', trigger: 'change' }],
      },
      fileCountMax: 4,
      fileList: [],
    });
    watch(
      () => props.modelValue,
      () => {
        state.eduList = props.modelValue.cvEducationalList || [];
      },
    );

    const handleRemove = (file) => {
      state.formData.fileUrl = state.formData.fileUrl.filter((item) => item.uid !== file.uid);
    };
    const beforeUpload = (file) => {
      const formatIsOk = ['image/jpeg', 'image/png', 'application/pdf'].includes(file.type);
      const isLt10M = file.size / 1024 / 1024 < 10;

      if (!formatIsOk) {
        ElMessage.error('附件必须是JPG/PNG/PDF格式!');
      }
      if (!isLt10M) {
        ElMessage.error('附件大小不能超过10MB!');
      }
      return formatIsOk && isLt10M;
    };
    const handleExceed = (files, fileList) => {
      ElMessage.warning(`限制上传${state.fileCountMax}个文件, 还可以上传 ${state.fileCountMax - fileList.length} 个文件`);
    };
    const handleSuccess = (res, file) => {
      if (res.code === 200 && res.data && res.data.url) {
        state.formData.fileUrl.push({ uid: file.uid, name: file.name, url: res.data.url });
      } else {
        ElMessage.error('上传失败，请稍后重试');
      }
    };

    const editFunc = (item) => {
      if (!props.modelValue.id) {
        return ElMessage.warning('请先填写基本信息');
      }
      let fileUrl = [];
      if (!item.id) {
        state.formData = { fileUrl, basicId: props.modelValue.id };
      } else {
        try {
          fileUrl = JSON.parse(item.fileUrl);
        } catch {
          fileUrl = [];
        }
        state.formData = { ...item, fileUrl, basicId: props.modelValue.id };
      }
      state.fileList = [...fileUrl];
      state.visible = true;
    };
    const deleteFunc = async (item) => {
      try {
        await ApplicantApi.deleteResumeEducation(item.id);
        context.emit('callback');
        ElMessage.success('删除成功');
      } catch (e) {
        console.error(e);
      }
    };

    const onSubmit = () => {
      state.formRef.validate(async (valid) => {
        if (valid) {
          const formData = { ...state.formData, fileUrl: JSON.stringify(state.formData.fileUrl) };
          Object.entries(formData).forEach(([key, value]) => {
            if (value instanceof Date) {
              formData[key] = formatDate('YYYY-MM-DD', value);
            }
          });
          try {
            if (formData.id) {
              await ApplicantApi.updateResumeEducation([formData]);
            } else {
              delete formData.id;
              await ApplicantApi.addResumeEducation([formData]);
            }
            ElMessage.success('保存成功');
            context.emit('callback');
            state.formRef.resetFields();
            state.visible = false;
          } catch (e) {
            console.error(e);
          }
        } else {
          return false;
        }
      });
    };
    const onReset = () => {
      state.visible = false;
      state.formRef.resetFields();
    };

    const store = useStore();
    const dicOptions = computed(() => store.state.dicOptions);
    return {
      router: useRouter(),
      ...toRefs(state),
      handleRemove,
      beforeUpload,
      handleExceed,
      handleSuccess,
      onSubmit,
      onReset,
      editFunc,
      deleteFunc,
      formatDate,
      getToken,
      dicOptions,
      EDUCATION,
    };
  },
};
</script>

<style scoped lang="scss">
.title {
  color: #000;
  font-size: 20px;
  padding: 30px 20px 10px;
  font-weight: 600;
  position: relative;
  ::before {
    content: '';
    position: absolute;
    width: 4px;
    height: 18px;
    background: #409eff;
    left: 8px;
    top: 36px;
  }
}
.desc {
  padding-left: 30px;
  font-size: 14px;
  margin: 7px 0 20px;
  color: #606266;
}
.edu_item {
  display: flex;
  align-items: center;
  padding: 20px;
  &:hover {
    box-shadow: 0 0 4px 0 rgb(0 0 0 / 30%);
    border-radius: 4px;
  }
  .left {
    flex: 1;
    display: flex;
    align-items: center;
    font-size: 16px;
    line-height: 22px;
    .part1 {
      margin-right: 20px;
    }
  }
  .actions {
    text-align: right;
  }
}
.form {
  position: relative;
  :deep(.el-upload__tip) {
    display: inline;
  }
}
.submit {
  margin-top: 30px;
  text-align: center;
}
</style>
